import { render, staticRenderFns } from "./NewJobBtn.vue?vue&type=template&id=56f7bfac&scoped=true&"
import script from "./NewJobBtn.vue?vue&type=script&lang=js&"
export * from "./NewJobBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7bfac",
  null
  
)

export default component.exports